// extracted by mini-css-extract-plugin
export default {"ff_platform_button":"PlatformButton_ff_platform_button__HoUqK"};